const NAMESPACE = "manageRequestDialog";

const KEYS = {
    resendESignaturesAdminInfoMsg: "resendESignaturesAdminInfoMsg"
};

const MESSAGES = {
    [KEYS.resendESignaturesAdminInfoMsg]: {
        value:
            "If one or more eSignature recipients did not receive a notification email, select Resend Notifications. If an email address needs to be corrected, edit it here or return to the form to update contact information and then select Resend Notifications. " +
            "Fixed recipients cannot be updated.",
        comment: "Demo localized header"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
